import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SubmenuDisplayHandlerService {
  private showSubmenu:Subject<Boolean> = new BehaviorSubject<Boolean>(false);
  constructor() { }

  getShowSubMenu():Observable<Boolean>{
    return this.showSubmenu.asObservable()
  }

  setShowSubMenu(data:Boolean){
    this.showSubmenu.next(data);
  }
}
